import { render } from "./FloatingCard.vue?vue&type=template&id=44f671e0&scoped=true&ts=true"
import script from "./FloatingCard.vue?vue&type=script&lang=ts"
export * from "./FloatingCard.vue?vue&type=script&lang=ts"

import "./FloatingCard.vue?vue&type=style&index=0&id=44f671e0&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f671e0"]])

export default __exports__